import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";

const TOAST_OPTIONS = {
  style: {
    background: "#1A1A2E",
    border: "1px solid rgba(44, 95, 138, 0.4)",
    color: "#F8FAFC",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
